import { useContext } from 'react';
import GlobalAlertContext from 'context/GlobalAlertContext';

export default () => useContext(GlobalAlertContext);
